import {
  Component,
  inject,
  TemplateRef,
} from '@angular/core';
import {
  DialogService,
} from '../../services/dialog.service';
import { ButtonComponent } from '../button/button.component';
import { CommonModule } from '@angular/common';
import { FocusTrapDirective } from '../../directives/focus-trap.directive';

@Component({
  selector: 'ppl-dialog',
  standalone: true,
  imports: [ButtonComponent, CommonModule, FocusTrapDirective],
  templateUrl: './dialog.component.html',
  styleUrl: './dialog.component.css',
})
export class DialogComponent {
  public dialogSvc = inject(DialogService);

  isTemplateRef(content: TemplateRef<any>) {
    return content instanceof TemplateRef;
  }

}
